<template>
  <div id="set-auth-withdrawal-modal">
    <modal :enableClose="false" :name="name" :hasModalFooter="false" @onShow="onShowModal">
      <template #body>
        <div v-if="!loading" class="body-wrapper">
          <p class="text-center title">Set Withdrawal Authentication</p>
          <div class="" style="display: flex; align-items: center; justify-content: space-between;">
            <p class="text-left">WA OTP</p>
            <label class="switch fl-left">
              <input type="checkbox" v-model="waOtp" />
              <span><i></i></span>
            </label>
          </div>
          <div class="" style="display: flex; align-items: center; justify-content: space-between;">
            <p class="text-left">Google Authenticator (GAuth)</p>
            <label class="switch fl-left">
              <input type="checkbox" v-model="gauth" />
              <span><i></i></span>
            </label>
          </div>
          <div class="" style="display: flex; align-items: center; justify-content: space-between;">
            <p class="text-left">Email Verification (Magic Link)</p>
            <label class="switch fl-left">
              <input type="checkbox" v-model="magicLink" />
              <span><i></i></span>
            </label>
          </div>
          <p v-if="errorMessage" style="width: 100%; color: red; text-align: center; margin-top: 20px;">
            {{ errorMessage }}
          </p>
          <div class="btn-group">
            <button class="btn-cancel" @click="close()">
              {{ $t('bank_account_management.cancel') }}
            </button>
            <button class="btn-add" @click="submit()">
              {{ $t('bank_account_management.add') }}
            </button>
          </div>
        </div>
        <div v-else style="height: 200px; display: flex; align-items: center; justify-content: center;">
          <svg xmlns="http://www.w3.org/2000/svg" class="spinner" width="100" height="100" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" />
            <path d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" fill="#333" />
          </svg>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from './Modal.vue';
import rf from '@/request/RequestFactory';

export default {
  name: 'SetAuthWithdrawal',
  components: { Modal },
  props: {
    name: {
      type: String,
      default: '',
    },
    getUser: {
      type: Function,
      required: false,
    },
    userWithdtawalAuth: { // ['waOtp', 'gauth']
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      waOtp: false,
      gauth: false,
      magicLink: false,
      errorMessage: '',
      loading: false,
    };
  },
  methods: {
    onShowModal(val) {
      this.$emit('onShow', val);
      if (val && this.userWithdtawalAuth) {
        this.waOtp = this.userWithdtawalAuth.includes('waOtp');
        this.gauth = this.userWithdtawalAuth.includes('gauth');
        this.magicLink = this.userWithdtawalAuth.includes('magicLink');
      }
    },
    close() {
      this.waOtp = false;
      this.gauth = false;
      this.magicLink = false;
      this.errorMessage = '';
      window.CommonModal.hide(this.name);
    },
    async submit () {
      const activeCount = [this.waOtp, this.gauth, this.magicLink].filter(Boolean).length;
      if (activeCount < 2) {
        this.errorMessage = 'Minimal 2 metode harus diaktifkan.';
        return;
      }
      this.errorMessage = '';
      this.loading = true;
      await rf.getRequest('UserRequest')
        .updateSetAuthWithdrawal({
          waOtp: this.waOtp,
          gauth: this.gauth,
          magicLink: this.magicLink,
        })
        .then((res) => {
          if (typeof this.getUser === 'function') {
            this.getUser(false);
            Message.success(
              this.$i18n.t('address.updated_success'),
              {},
              { position: 'top_right' }
            );
          }
        })
        .catch((err) => {
          if (!err.response) {
            Message.error(this.$i18n.t('common.message.network_error'));
          }
        })
        .finally(() => {
          this.loading = false;
        });
      this.close();
    },
  },
};
</script>

<style>
@keyframes spin {
  to { transform: rotate(360deg); }
}
.spinner {
  animation: spin 1s linear infinite;
}
</style>

<style lang="scss" scoped>
#set-auth-withdrawal {
  .body-wrapper {
    // padding: 0 30px 30px 30px;
  }

  input {
    padding: 9px 16px;
    border-radius: 8px;
    border: 1px solid $bg-main2;
    background: $text-main1;
    width: 100%;
    color: $text-main;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    &:focus {
      border: 1px solid $bg-main1;
    }

    @include mobile {
      font-size: 14px;
      line-height: 22px;
      font-weight: 300;
      height: 40px;
    }

    &::placeholder {
      color: $text-main-blur;
    }

    &:disabled {
      color: $text-main-blur;
      -webkit-text-fill-color: $text-main-blur;
    }
  }

  :deep {
    .modal-dialog {
      width: 100%;
      max-width: 414px;

      @include mobile {
        width: calc(100vw - 30px) !important;
        padding: 0;
        transform: translate(0, 0) !important;
        top: 80px;
        left: 15px;

        .modal-body {
          padding: 16px 16px 24px;
        }
      }
    }

    .button_drop_search {
      border: 1px solid $bg-main2;
      padding: 8px 16px;

      @include mobile {
        height: 40px;
      }

      span {
        color: $text-main;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;

        @include mobile {
          font-size: 14px;
          line-height: 22px;
          font-weight: 300;
        }
      }

      .isPlaceholder {
        color: $text-main-blur;
      }

      i {
        font-size: 18px;
      }
    }
  }
}

.btn-add[disabled] {
  &:hover {
    opacity: unset !important;
  }

  cursor: no-drop;
}

.title {
  font-size: 24px;
  color: $text-main;
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 30px;

  @include mobile {
    font-size: 18px;
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 16px;
  }
}

.input-field__wrapper {
  margin-bottom: 16px;
}

.field-label {
  color: $text-secondary;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  @include mobile {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 8px;
    font-weight: 400;
  }

  span {
    color: $color-red;
  }
}

.field-input__inner {
  position: relative;
}

.fill-auto-label {
  color: rgba($text-main2, 0.38);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 8px;

  @include mobile {
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;
  }
}

.btn-group {
  margin-top: 24px;
  display: flex;
  gap: 16px;

  .btn-cancel {
    @include btn-common(contained, md);
    background: $bg-main3;
    color: $text-main;
  }

  .btn-add {
    @include btn-common(contained, md);
  }
}

.icon-container {
  display: none;
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);

  &.active {
    display: block;
  }
}

.loader {
  position: relative;
  height: 20px;
  width: 20px;
  display: inline-block;
  animation: around 5.4s infinite;
}

@keyframes around {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loader::after,
.loader::before {
  content: '';
  background: white;
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-color: #333 #333 transparent transparent;
  border-style: solid;
  border-radius: 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  animation: around 0.7s ease-in-out infinite;
}

.loader::after {
  animation: around 0.7s ease-in-out 0.1s infinite;
  background: transparent;
}

.bank_select :deep() {
  .group_search_select > .box_list_search_select {
    width: 100%;
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.16);

    ul li {
      .full_name_coin_select {
        @include mobile {
          color: $text-main;
          font-size: 16px;
          font-weight: 300;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.admin-add-bank {
  color: red;
  .admin-hyperlink {
    color: rgb(46, 154, 225);
    text-decoration: underline;
  }
}

.admin-add-bank:hover {
  color: rgb(226, 0, 0);
  .admin-hyperlink {
    color: rgb(1, 135, 224);
  }
}
</style>
